// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Ae4t","controls":"styles_controls__LeLlo","charLimit":"styles_charLimit__3stCg","input":"styles_input__1CsTV","send":"styles_send__2UMyT"};